import { useEffect } from 'react';
import { getKambiConfig, getTicket, getUserId } from '../utils/utils';
import { subscribe, unsubscribe } from '../../../utils/events';
import { useKambiWidgetScript } from './use-kambi-widget-script';

/**
 * Hook que sincroniza el estado de autenticación con el widget de Kambi.
 * 
 * Escucha los eventos LOGIN_SUCCESS y LOGOUT_SUCCESS emitidos por el contexto
 * de autenticación y actualiza el estado del widget de Kambi en consecuencia.
 * 
 * Comportamiento:
 * - LOGIN_SUCCESS: Obtiene el ticket y playerId, luego ejecuta wapi.request(wapi.LOGIN)
 *   con los datos del usuario. No recarga la página, solo sincroniza el estado.
 * - LOGOUT_SUCCESS: Ejecuta wapi.request(wapi.LOGOUT) para cerrar sesión en el widget.
 * 
 * Esto permite que el widget de Kambi se mantenga sincronizado con el estado de
 * autenticación de la aplicación sin necesidad de recargar la página completa.
 */

export const useKambiWidget = (isBootstrapReady) => {
  const status = useKambiWidgetScript();

  const onLogoutSuccess = () => {
    window?.KambiWidget?.ready?.then(wapi => {
      wapi.request(wapi.LOGOUT);
    });
  };

  const onLoginSuccess = async (event) => {
    const kambiConfig = await getKambiConfig(true);

    if (!kambiConfig) {
      console.error('Kambi config not found');
      return;
    }

    kambiConfig.punterId = kambiConfig.playerId;
    delete kambiConfig.playerId;

    window?.KambiWidget?.ready?.then(wapi => {
      wapi.request(wapi.LOGIN, kambiConfig);
    });
  };

  useEffect(() => {
    subscribe('LOGOUT_SUCCESS', onLogoutSuccess);
    subscribe('LOGIN_SUCCESS', onLoginSuccess);

    return () => {
      unsubscribe('LOGOUT_SUCCESS', onLogoutSuccess);
      unsubscribe('LOGIN_SUCCESS', onLoginSuccess);
    };
  }, [status]);
};